export const BASE_SHEEP_GATHERING_RATE: number = 37.05;
export const BASE_CATTLE_GATHERING_RATE: number = 40.78;
export const BASE_BERRY_GATHERING_RATE: number = 32.93;
export const BASE_DEER_GATHERING_RATE: number = 41.7;
export const BASE_FARM_GATHERING_RATE: number = 36.718;
export const BASE_GOLD_GATHERING_RATE: number = 37;
export const BASE_WOOD_GATHERING_RATE: number = 31;
export const BASE_STONE_GATHERING_RATE: number = 37;
export const STOCKYARD_GATHERING_RATE: number = 38.67;
